export default {
    name: "RecentProjectsWidget",
    type: "DataWidget",
    description: "Displays a list of your most recently modified video projects.",
    roles: ["appUser"],
    widget: {
        title: "Recent Projects",
        size: "large",
        dataProvider: {
            main: {
                rpc: "VideoProjectRpc.getData",
                params: {
                    sort: { updatedAt: -1 },
                    pageSize: 5
                },
                // Transform the standard DataCrud response { data: [], totalCount: N } to just the array
                transform: (response) => response.data
            }
        },
        itemAction: {
            type: "navigate",
            route: "/user/editor?projectId={{_id}}"
        },
        fields: [
            { name: "name", isTitle: true },
            { name: "status", isSubtitle: true, render: (val) => val.replace(/_/g, ' ').toUpperCase() },
            { name: "updatedAt", isMeta: true, render: (val) => new Date(val).toLocaleDateString() }
        ],
        noDataMessage: "No projects yet. Start creating!"
    }
};